/**
 * Canvas element helpers shared by the pure rendering operations.
 * The owning document is passed explicitly to keep the functions SSR-safe
 * and unit-testable without a renderer instance.
 */
export function createCanvas(document: Document, width: number, height: number): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(width));
  canvas.height = Math.max(1, Math.round(height));
  return canvas;
}

export function cloneCanvas(document: Document, sourceCanvas: HTMLCanvasElement): HTMLCanvasElement {
  const canvas = createCanvas(document, sourceCanvas.width, sourceCanvas.height);
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    return sourceCanvas;
  }

  ctx.drawImage(sourceCanvas, 0, 0);
  return canvas;
}
